<template>
  <div class="big-title">
    <span></span>
    <h2 class="big-title-text">
      {{ title }}
    </h2>
    <span></span>
  </div>
</template>

<script>
export default {
  name: "BigTitle",
  props: {
    title: String
  }
}
</script>

<style scoped>
.big-title {
  font-weight: bold;
  font-size: 2.3rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  /*background-image: url(../../../../assets/images/other/product.png);*/
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  gap: 1rem;
}
.big-title span{
  display: inline-block;
  flex-grow: 1;
  height: 1px;
  background-color: #00000062;
}
.big-title-text {
  
  font-weight: bolder;
  text-align: center;
  
  
}
@media screen and (max-width:600px) {
  .big-title-text {
    font-size: 20px;    
  }
}
</style>
